import { useNuxtApp } from '#app';

export function mayaApiClient() {
  const nuxtApp = useNuxtApp();
  const axios = nuxtApp.$axios || nuxtApp.$vuex?.$axios;

  if (!axios) {
    throw new Error('API client is not available');
  }

  return axios;
}
